export default {
    isAppLoading: true,
    isAppInitialized: false,
    isAppInitializing: false,
    authUserAppResource: null,
};
